import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { restoreColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getRestore } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "status", "created_at", "last_updated"];

const TmobilejRestoreBatch = () => (
  <BatchDetail
    title="Restore"
    apiGet={__getRestore}
    client={CLIENTS.tmobilej}
    columnsFactory={restoreColumns}
    copyKeys={COPY_KEYS}
    exportAction="restore"
    retryOperation="restore"
    showTerminate
    getRowPath={(row) => `/tmobilej/restore/${row.id}`}
  />
);

export default TmobilejRestoreBatch;
